<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <div style="position: relative">
        <v-btn
          v-if="readOnly"
          absolute
          fab
          top
          right
          dark
          color="primary"
          @click="editItem"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <br />
      <br />
      <form>
        <v-row dense>
          <v-col cols="12" sm="10" md="10">
            <h5>Gambar</h5>
            <v-img
              v-if="struktur_organisasi.foto_url_original"
              :src="struktur_organisasi.foto_url"
              contain
              :key="struktur_organisasi.fotoKey"
              max-height="300"
            ></v-img>
            <v-img
              v-else
              src="https://www.generationsforpeace.org/wp-content/uploads/2018/03/empty.jpg"
              contain
              max-height="300"
            ></v-img>
            <v-file-input
              v-if="!readOnly"
              @change="loadImage"
              accept="image/*"
              v-model="struktur_organisasi.poster_url"
              prepend-icon="mdi-image"
              show-size
              label="Gambar (1000x1510) px"
            />
          </v-col>
        </v-row>
        <v-row v-if="!readOnly">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn @click="doBatal" style="margin-right: 10px">Batal</v-btn>
            <v-btn dark color="primary" type="submit" @click.prevent="doSubmit"
              >Simpan</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </v-container>
  </v-main>
</template>

<script>
import StrukturOrganisasiService from "../../services/web_content/StrukturOrganisasiService";
import CommonService from "../../services/CommonService";

export default {
  name: "StrukturOrganisasi",
  components: {},
  props: {},
  data: () => ({
    breadcrumbs: [
      {
        text: "Struktur Organisasi",
        disabled: false,
        exact: true,
        to: { name: "strukturOrganisasi" },
      },
      { text: "Detail", disabled: true },
    ],
    readOnly: true,
    struktur_organisasi: {
      id: null,
      foto_url_original: null,
      foto_url: null,
      fotoKey: 0,
      poster_url: null,
    },
  }),
  computed: {
    outlined() {
      return this.readOnly;
    },
    hideDetails() {
      return true;
    },
  },
  mounted: async function () {
    this.fetchStrukturOrganisasi();
  },
  methods: {
    loadImage: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.struktur_organisasi.foto_url = e.target.result;
          this.struktur_organisasi.foto_url_original =
            this.struktur_organisasi.foto_url;
          this.struktur_organisasi.fotoKey++;
        };
        reader.readAsDataURL(data);
      }
    },
    fetchStrukturOrganisasi: async function () {
      try {
        console.log("fetch");
        StrukturOrganisasiService.strukturOrganisasi()
          .then((res) => {
            if (res.data.struktur_organisasi) {
              this.struktur_organisasi = res.data.struktur_organisasi;
              console.log(this.struktur_organisasi);
              console.log(this.struktur_organisasi.id);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (e) {
        console.error("error:", e);
      }
    },

    editItem: async function () {
      this.readOnly = false;
    },

    doBatal: function () {
      this.readOnly = true;
    },

    doSubmit: async function () {
      try {
        console.log(this.struktur_organisasi.id);
        if (this.struktur_organisasi.id != null) {
          StrukturOrganisasiService.update(this.struktur_organisasi)
            .then((res) => {
              console.log(res);
              CommonService.showSuccessToast(
                "Update struktur organisasi berhasil"
              );

              this.fetchStrukturOrganisasi();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast(
                "Update struktur organisasi gagal. Coba lagi"
              );
            });
        } else {
          StrukturOrganisasiService.create(this.struktur_organisasi)
            .then((res) => {
              console.log(res);
              this.dialog = false;
              CommonService.showSuccessToast(
                "Tambah struktur organissi berhasil"
              );

              this.fetchStrukturOrganisasi();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast(
                "Tambah struktur organisasi gagal. Coba lagi"
              );
            });
        }
      } catch (e) {
        console.error("error:", e);
      }
    },
  },
};
</script>

<style scoped>
</style>
